import BasicContentTextCardItem from './BasicContentTextCardItem';

export { type BasicContentTextCardItemProps } from './BasicContentTextCardItem';
export default BasicContentTextCardItem;
